/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Toast_ForbiddenInputs */

const en_toast_forbidden = /** @type {(inputs: Toast_ForbiddenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You cannot change this item. Ask an admin of the space for access.`)
};

const de_toast_forbidden = /** @type {(inputs: Toast_ForbiddenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Du kannst diesen Vorgang nicht ändern. Bitte eine Person mit Admin-Rechten im Bereich um Zugriff.`)
};

/**
* | output |
* | --- |
* | "You cannot change this item. Ask an admin of the space for access." |
*
* @param {Toast_ForbiddenInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const toast_forbidden = /** @type {((inputs?: Toast_ForbiddenInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Toast_ForbiddenInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_toast_forbidden(inputs)
	return en_toast_forbidden(inputs)
});